import { CrGrid, ICrGrid } from 'com-ui/data-grid/cr-grid'
import { css } from 'styled-components'

export function TableList(props: ICrGrid) {
  return (
    <CrGrid
      resizableColumns={false}
      {...props}
      customStyles={css`
        ${tableStyle}
        ${props.customStyles}
      `}
    />
  )
}

const tableStyle = css`
  .p-datatable-thead {
    .p-column-title {
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
      color: var(--indigo-8);
    }
    tr > th {
      border: none;
      background: var(--indigo-2);
    }
  }

  .p-datatable-scrollable-header {
    background: var(--indigo-2);
    border-radius: var(--round-8);
  }

  .p-datatable-tbody > tr {
    td.vertical-align-top {
      vertical-align: top;
    }
  }

  .p-datatable-hoverable-rows .p-datatable-tbody > tr {
    cursor: pointer;

    td {
      border: 2px solid var(--indigo-2);
      border-width: 0 0 1px 0;
      line-height: 24px;
      color: var(--gray-8);
      padding: 8px 16px;

      .freshdesk-link {
        cursor: pointer;
        color: var(--blue-2);
      }

      .status {
        padding: 4px 16px;
      }
    }

    &:first-child {
      td {
        border-top: none;
      }
    }
    &:last-child {
      td {
        border-bottom: none;
      }
    }

    &.p-highlight,
    &:not(.p-highlight):hover {
      outline: none;
      background-color: var(--indigo-2);

      .sticky-col {
        background-color: var(--indigo-2);
      }
    }
  }
`
